module.exports = __webpack_public_path__ + "static/media/microinteractions.8b14f7e6.png";